'use client';

import { Badge } from '@terra/ui-design-system';
import {
  BotIcon,
  CircleIcon,
  HandGrabIcon,
  Key01Icon,
  FlashIcon,
} from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import type { CrawlerSessionType } from '../../hooks/useCrawlerSessions';

type CrawlerTypeIndicatorProps = {
  type: CrawlerSessionType;
  size?: 'sm' | 'md';
};
const typeConfig: Partial<
  Record<
    CrawlerSessionType,
    {
      labelKey:
        | 'shallow'
        | 'ai'
        | 'manual'
        | 'authentication'
        | 'featureAnalysis'
        | 'navigationProfile';
      icon: React.ReactNode;
    }
  >
> = {
  SHALLOW: {
    labelKey: 'shallow',
    icon: <FlashIcon size={10} />,
  },
  AI: {
    labelKey: 'ai',
    icon: <BotIcon size={10} />,
  },
  MANUAL: {
    labelKey: 'manual',
    icon: <HandGrabIcon size={10} />,
  },
  AUTHENTICATION: {
    labelKey: 'authentication',
    icon: <Key01Icon size={10} />,
  },
  FEATURE_ANALYSIS: {
    labelKey: 'featureAnalysis',
    icon: <BotIcon size={10} />,
  },
  NAVIGATION_PROFILE: {
    labelKey: 'navigationProfile',
    icon: <BotIcon size={10} />,
  },
};

export function CrawlerTypeIndicator({
  type,
  size = 'sm',
}: CrawlerTypeIndicatorProps) {
  const t = useTranslations('crawler.typeIndicator');
  const config = typeConfig[type];

  if (!config) {
    return (
      <Badge variant="outline" size={size} icon={<CircleIcon size={10} />}>
        {type}
      </Badge>
    );
  }

  return (
    <Badge variant="outline" size={size} icon={config.icon}>
      {t(config.labelKey)}
    </Badge>
  );
}
